exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-link[data-v-d11553be] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  min-width: 150px;\n}\n.choice[data-v-d11553be],\n.link-title[data-v-d11553be] {\n  display: block;\n  line-height: 32px;\n  white-space: nowrap;\n  font-size: 12px;\n}\n", ""]);

// exports
